module.exports = __webpack_public_path__ + "img/Share of voice Icon - charcoal.ab34b68f.svg";